import React from 'react'

const CenterComponent = ({ title, text, imageUrl }) => {
    return (
        <div className='CenterComponent'>
          <div className='CenterComponent-img'>
            <img src={imageUrl} alt="section-img" className="CenterComponent-image-container" />
          </div>

          <div className='CenterComponent-paragraph'>
            <h3 className='CenterComponent-paragraph-title'>{title}</h3>
            <p className='CenterComponent-paragraph-paragraph'>{text}</p>
          </div>
        </div>
      )
    }

export default CenterComponent